// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1636":"68261ef8","4642":"2f612be1","6931":"0d08c151","9884":"bcf6b87e"}[chunkId] + ".chunk.css";
};